import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledAgendaScheduleDate = styled(Flexbox)(
    ({theme: {palette}}) => css`
        color: ${palette.neutral['950']};
    `
)

export const StyledAgendaScheduleDayNumber = styled.p<{$isSelected: boolean}>(
    ({theme: {palette}, $isSelected}) => css`
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 30px;
        color: ${palette.neutral['600']};
        ${$isSelected &&
        css`
            background-color: ${palette.primary['500']};
            border-radius: 100%;
            color: ${palette.neutral['white']};
        `}
    `
)

export const StyledAgendaScheduleDay = styled.p(
    ({theme: {typography}}) => css`
        ${typography.textXs};
    `
)
